<template>
  <div class="check" v-loading="isLoading">
    <div class="check-back">
      <el-button
        icon="el-icon-back"
        circle
        size="mini"
        v-if="station"
        @click="onGetLatest"
      ></el-button>
    </div>
    <div class="check-content">
      <el-descriptions
        :title="title"
        direction="vertical"
        :column="1"
        border
        size="small"
      >
        <el-descriptions-item label="地址：" v-if="station !== null">{{
          station.elecAdd
        }}</el-descriptions-item>
        <el-descriptions-item label="创建时间：">{{
          param.createTime | timeFormatter
        }}</el-descriptions-item>
        <el-descriptions-item label="到场时间：">{{
          param.locateDate | timeFormatter
        }}</el-descriptions-item>
        <el-descriptions-item label="离场时间：">
          {{ param.leaveDate | timeFormatter }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="check-photo" v-if="photoList.length > 0">
      <p>
        巡场图片
        <span>{{ `(共${photoList.length}张，点击图片查看)` }}</span>
      </p>
      <el-image
        style="width: 360px; height: 200px"
        :src="photoSrc"
        fit="contain"
        :preview-src-list="photoList"
      >
      </el-image>
    </div>
    <div class="check-pdf" v-if="pdfList.length > 0">
      <p>巡场文件</p>
      <a
        class="check-pdf-item"
        v-for="(item, index) in pdfList"
        :key="index"
        :href="item"
        target="blank"
      >
        {{ `文件-${index + 1}` }}
      </a>
    </div>
    <div class="check-download" v-if="station">
      <el-popover placement="right" width="500" trigger="click">
        <div class="popover-box">
          <el-date-picker
            size="small"
            v-model="downloadTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            value-format="yyyy-MM-dd hh:mm:ss"
            end-placeholder="结束日期"
          >
          </el-date-picker>
          <el-button
            type="primary"
            :disabled="downloadTime.length === 0"
            :loading="isDownloadLoading"
            size="small"
            icon="el-icon-download"
            @click="onDownload"
            >确认</el-button
          >
        </div>

        <el-button slot="reference" type="text">下载</el-button>
      </el-popover>
    </div>
  </div>
</template>

<script>
import HTTP_STATION from "@/api/station";
import JsFileDownload from "js-file-download";
export default {
  name: "CheckInfo",
  props: {
    station: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
      isDownloadLoading: false,
      downloadTime: "",
      param: {
        id: 6,
        locateDate: "",
        leftDate: "",
        photoUrl: "",
        checkPdf: "",
        stationId: "",
        createTime: "",
      },
      photoSrc: "",
      photoList: [],
      pdfList: [],
    };
  },
  watch: {
    station: {
      deep: true,
      handler() {
        this.getInfo();
      },
      immediate: true,
    },
  },
  computed: {
    title() {
      return this.station === null ? "最新巡查信息" : this.station.elecName;
    },
  },
  filters: {
    timeFormatter(timestamp) {
      function addZero(m) {
        return m < 10 ? "0" + m : m;
      }
      if (timestamp) {
        var time = new Date(timestamp);
        var y = time.getFullYear();
        var M = time.getMonth() + 1;
        var d = time.getDate();
        var h = time.getHours();
        var m = time.getMinutes();
        var s = time.getSeconds();
        return (
          y +
          "-" +
          addZero(M) +
          "-" +
          addZero(d) +
          " " +
          addZero(h) +
          ":" +
          addZero(m) +
          ":" +
          addZero(s)
        );
      } else {
        return "暂无数据";
      }
    },
  },
  methods: {
    onGetLatest() {
      this.$emit("getLatest", null);
    },
    async getInfo() {
      this.isLoading = true;
      try {
        var res;
        if (this.station === null) {
          res = await HTTP_STATION.getLatestStationInfo();
        } else {
          res = await HTTP_STATION.getLatestStationInfo({
            stationId: this.station.id,
          });
        }
        if (res.code === 200) {
          this.param = res.data;
          this.handlePhoto();
          this.handlePdf();
        } else {
          this.$message.error(
            typeof res.msg === "string" ? res.msg : "请求出错，请联系管理员"
          );
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },
    handlePhoto() {
      if (this.param.photoUrl.length > 0) {
        var list = this.param.photoUrl.split(",");
        list.forEach((item, index) => {
          if (index === 0) {
            this.photoSrc = item;
          }
          this.photoList.push(item);
        });
      }
    },
    handlePdf() {
      if (this.param.checkPdf.length > 0) {
        var list = this.param.checkPdf.split(",");
        list.forEach((item) => {
          this.pdfList.push(item);
        });
      }
    },
    async onDownload() {
      if (this.downloadTime.length === 0 || this.station === null) {
        return;
      }
      const param = {
        startTime: this.downloadTime[0],
        endTime: this.downloadTime[1],
        stationId: this.station.id,
      };
      try {
        this.isDownloadLoading = true;
        const res = await HTTP_STATION.downloadFile(param);
        JsFileDownload(res, "巡场文件.zip");
        console.log(res);
      } catch (e) {
        console.error(e);
      } finally {
        this.isDownloadLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scope>
.popover-box {
  display: flex;
  justify-content: space-around;
}
.check {
  width: 400px;
  // height: 500px;
  position: absolute;
  top: 60px;
  left: 10px;
  z-index: 10;
  background-color: #ffffff;
  border-radius: 5px;
  padding: 24px 12px;
  &-back {
    position: absolute;
    top: 10px;
    right: 12px;
  }
  &-photo,
  &-pdf {
    p {
      font-weight: bold;
      span {
        font-size: 12px;
        font-weight: normal;
        color: #3c3c3c;
      }
    }
    margin: 10px 0;
  }
  &-pdf {
    a {
      display: inline-block;
      padding: 5px 16px;
      color: #409eff;
      font-size: 14px;
    }
  }
  &-download {
    margin: 20px 20px 0 0;
    text-align: right;
  }
}
</style>
